import {Button, Form, Input} from 'antd';
import PropTypes from 'prop-types';
import {useState} from 'react';
import toast from 'react-hot-toast';

import {
  RQGenerateOtpEmail,
  RQGenerateOtpMobile,
  RQVerifyOtpEmail,
  RQVerifyOtpMobile,
} from '../../../../reactQuery/apis';

const RegistrationForm = ({onSubmit}) => {
  const [form] = Form.useForm();

  const [emailOtpSent, setEmailOtpSent] = useState(false);
  // const [mobileOtpSent, setMobileOtpSent] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);
  // const [mobileVerified, setMobileVerified] = useState(false);

  const {mutateAsync: generateMobileOtp, isPending: mobileSending} =
    RQGenerateOtpMobile();

  const {mutateAsync: verifyMobileOtp, isPending: mobileVerifying} =
    RQVerifyOtpMobile();

  const {mutateAsync: generateEmailOtp, isPending: emailSending} =
    RQGenerateOtpEmail();

  const {mutateAsync: verifyEmailOtp, isPending: emailVerifying} =
    RQVerifyOtpEmail();

  const resetOtpStates = () => {
    setEmailOtpSent(false);
    // setMobileOtpSent(false);
    setEmailVerified(false);
    // setMobileVerified(false);
  };

  const handleRegister = async values => {
    if (!emailVerified) {
      toast.error('Please verify email first');
      return;
    }

    // if (!mobileVerified) {
    //   toast.error('Please verify mobile number first');
    //   return;
    // }

    try {
      const payload = {
        ...values,
        // mobile: String(values.mobile).trim(),
        email: values.email.trim(),
        // verifcation: emailVerified && mobileVerified,
      };

      await onSubmit(payload);

      form.resetFields();
      resetOtpStates();
      toast.success('Registration successful');
    } catch (error) {
      console.log('REGISTER ERROR:', error);

      let backendMessage = 'Registration failed';

      if (error?.response?.data) {
        if (typeof error.response.data === 'string') {
          backendMessage = error.response.data;
        } else if (error.response.data.message) {
          backendMessage = error.response.data.message;
        }
      } else if (error?.message) {
        backendMessage = error.message;
      }
      
      toast.error(backendMessage);

      const lowerMsg = backendMessage.toLowerCase();
      const fieldErrors = [];

      if (lowerMsg.includes('email')) {
        fieldErrors.push({
          name: 'email',
          errors: [backendMessage],
        });
      }

      if (lowerMsg.includes('mobile') || lowerMsg.includes('phone')) {
        fieldErrors.push({
          name: 'mobile',
          errors: [backendMessage],
        });
      }

      if (fieldErrors.length) {
        form.setFields(fieldErrors);
      }
    }
  };

  // const handleSendMobileOtp = async () => {
  //   const mobile = form.getFieldValue('mobile')?.toString().trim();

  //   if (!mobile) {
  //     toast.error('Please enter mobile number first');
  //     return;
  //   }

  //   try {
  //     await generateMobileOtp(mobile);
  //     setMobileOtpSent(true);
  //     toast.success('OTP sent to your mobile number');
  //   } catch (error) {
  //     console.log('MOBILE OTP ERROR:', error);

  //     let backendMessage = 'Failed to send OTP';

  //     if (error?.response?.data) {
  //       if (typeof error.response.data === 'string') {
  //         backendMessage = error.response.data;
  //       } else if (error.response.data.message) {
  //         backendMessage = error.response.data.message;
  //       }
  //     } else if (error?.message) {
  //       backendMessage = error.message;
  //     }

  //     toast.error(backendMessage);
  //   }
  // };

  // const handleVerifyMobileOtp = async () => {
  //   const mobile = form.getFieldValue('mobile')?.toString().trim();
  //   const otp = form.getFieldValue('mobileOtp')?.toString().trim();

  //   if (!otp) {
  //     toast.error('Please enter mobile OTP');
  //     return;
  //   }

  //   try {
  //     await verifyMobileOtp({mobile, otp});
  //     setMobileVerified(true);
  //     toast.success('Mobile number verified successfully');
  //   } catch (error) {
  //     toast.error(error?.message || 'Invalid OTP');
  //   }
  // };

  const handleSendEmailOtp = async () => {
    const email = form.getFieldValue('email')?.trim();

    if (!email) {
      toast.error('Please enter email first');
      return;
    }

    try {
      await generateEmailOtp(email);
      setEmailOtpSent(true);
      toast.success('OTP sent to your email');
    } catch (error) {
      console.log('EMAIL OTP ERROR:', error);

      let backendMessage = 'Failed to send OTP';

      if (error?.response?.data) {
        if (typeof error.response.data === 'string') {
          backendMessage = error.response.data;
        } else if (error.response.data.message) {
          backendMessage = error.response.data.message;
        }
      } else if (error?.message) {
        backendMessage = error.message;
      }

      toast.error(backendMessage);
    }
  };

  const handleVerifyEmailOtp = async () => {
    const email = form.getFieldValue('email')?.trim();
    const otp = form.getFieldValue('emailOtp')?.toString().trim();

    if (!otp) {
      toast.error('Please enter email OTP');
      return;
    }

    try {
      await verifyEmailOtp({email, otp});
      setEmailVerified(true);
      toast.success('Email verified successfully');
    } catch (error) {
      toast.error(error?.message || 'Invalid OTP');
    }
  };

  return (
    <div>
      <h2 className={'md:text-3xl text-xl md:mb-8 mb-5 text-primary-900 flex font-semibold w-full justify-center'}>
        Create Your Account
      </h2>

      <Form form={form} layout={'vertical'} onFinish={handleRegister}>
        <div className={'flex gap-2'}>
          <Form.Item
            label={'First Name'}
            name={'firstName'}
            rules={[
              {required: true, message: 'Please enter your First Name'},
              {pattern: /^[A-Za-z]+$/, message: 'Only letters are allowed'},
            ]}
            className={'w-full'}
          >
            <Input placeholder={'Enter First Name'} />
          </Form.Item>

          <Form.Item
            label={'Last Name'}
            name={'lastName'}
            rules={[
              {required: true, message: 'Please enter your Last Name'},
              {pattern: /^[A-Za-z]+$/, message: 'Only letters are allowed'},
            ]}
            className={'w-full'}
          >
            <Input placeholder={'Enter Last Name'} />
          </Form.Item>
        </div>

        <Form.Item
          label={'Mobile Number'}
          name={'mobile'}
          rules={[
            {required: true, message: 'Mobile number is required'},
            {pattern: /^[0-9]{10}$/, message: 'Must be 10 digits'},
          ]}
        >
          <Input
            maxLength={10}
            placeholder={'Enter mobile number'}
            // addonAfter={(
            //   <Button
            //     type={'link'}
            //     size={'small'}
            //     loading={mobileSending}
            //     disabled={mobileVerified}
            //     onClick={handleSendMobileOtp}
            //   >
            //     Send OTP
            //   </Button>
            // )}
          />
        </Form.Item>
        {/* 
        {mobileOtpSent && !mobileVerified && (
          <Form.Item label={'Mobile OTP'} name={'mobileOtp'}>
            <Input
              placeholder={'Enter Mobile OTP'}
              addonAfter={(
                <Button
                  type={'link'}
                  size={'small'}
                  loading={mobileVerifying}
                  onClick={handleVerifyMobileOtp}
                >
                  Verify
                </Button>
              )}
            />
          </Form.Item>
        )}

        {mobileVerified && (
          <p style={{color: 'green'}}>Mobile verified successfully</p>
        )} */}

        <Form.Item
          label={'Email'}
          name={'email'}
          rules={[
            {required: true, message: 'Email is required'},
            {type: 'email', message: 'Enter valid email'},
          ]}
        >
          <Input
            placeholder={'Enter email'}
            addonAfter={(
              <Button
                type={'link'}
                size={'small'}
                loading={emailSending}
                disabled={emailVerified}
                onClick={handleSendEmailOtp}
              >
                Send OTP
              </Button>
            )}
          />
        </Form.Item>

        {emailOtpSent && !emailVerified && (
          <Form.Item label={'Email OTP'} name={'emailOtp'}>
            <Input
              placeholder={'Enter Email OTP'}
              addonAfter={(
                <Button
                  type={'link'}
                  size={'small'}
                  loading={emailVerifying}
                  onClick={handleVerifyEmailOtp}
                >
                  Verify
                </Button>
              )}
            />
          </Form.Item>
        )}

        {emailVerified && (
          <p style={{color: 'green'}}>Email verified successfully</p>
        )}

        <Form.Item
          label={'Password'}
          name={'password'}
          rules={[
            {required: true, message: 'Password is required'},
            {min: 6, message: 'Minimum 6 characters required'},
          ]}
        >
          <Input.Password placeholder={'Enter password'} />
        </Form.Item>

        <Form.Item
          label={'Address'}
          name={'address'}
          rules={[{required: true, message: 'Address is required'}]}
        >
          <Input.TextArea rows={3} placeholder={'Enter address'} />
        </Form.Item>

        <Button htmlType={'submit'} type={'primary'} className={'w-full mt-3'}>
          Register
        </Button>
      </Form>
    </div>
  );
};

RegistrationForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default RegistrationForm;
